'use client'

import * as React from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { Popover as PopoverPrimitive } from 'radix-ui'

const Popover = PopoverPrimitive.Root
const PopoverClose = PopoverPrimitive.Close
const PopoverTrigger = PopoverPrimitive.Trigger
const PopoverAnchor = PopoverPrimitive.Anchor
const PopoveArrow = PopoverPrimitive.Arrow

const PopoverContentWithoutPortal = React.forwardRef<
	React.ElementRef<typeof PopoverPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ align, sideOffset, className, ...props }, ref) => (
	<PopoverPrimitive.Content
		align={align}
		className={cn(
			'bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 rounded-md p-4 shadow-lg outline-none',
			className,
		)}
		ref={ref}
		sideOffset={sideOffset}
		{...props}
	/>
))

const PopoverContent = React.forwardRef<
	React.ElementRef<typeof PopoverPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
		container?: HTMLElement | null
	}
>(({ container, ...props }, ref) => (
	<PopoverPrimitive.Portal container={container}>
		<PopoverContentWithoutPortal
			ref={ref}
			{...props}
		/>
	</PopoverPrimitive.Portal>
))

PopoverContent.displayName = PopoverPrimitive.Content.displayName

export {
	Popover,
	PopoverAnchor,
	PopoverClose,
	PopoverContent,
	PopoverContentWithoutPortal,
	PopoverTrigger,
	PopoveArrow,
}
